export const breakpoints = [
    "360px", // mobileSm
    "560px", // mobileLg
    "768px", // tabletSm
    "1024px", // tabletLg
    "1366px", // desktopSm
    "1540px", // desktopMd
    "1920px", // desktopLg
    "2560px", // desktopXl
] as const;

export const labels = [
    "mobileSm",
    "mobileLg",
    "tabletSm",
    "tabletLg",
    "desktopSm",
    "desktopMd",
    "desktopLg",
    "desktopXl",
] as const;

export type BreakPointsType = {
    [key in (typeof labels)[number]]: string;
};
